export enum PlanBenefitOverrideRuleStatus {
  DRAFT = 'DRAFT',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export enum PlanBenefitOverrideValueSource {
  REAL_DATA = 'REAL_DATA',
  IDEON_DATA = 'IDEON_DATA',
  OVERRIDE_DATA = 'OVERRIDE_DATA',
}

// Synthetic UI-only status key for the Deleted sub-tab.
// BE drives deleted-rule data via GET /api/v1/plan-benefit-override-rules/deleted (not yet implemented).
export const DELETED_TAB_KEY = 'DELETED' as const
export type DeletedTabKey = typeof DELETED_TAB_KEY

export enum PlanBenefitOverrideRuleTemplateKey {
  PARTIAL_FIELD_UPDATE = 'PARTIAL_FIELD_UPDATE',
  UPSERT_RULE = 'UPSERT_RULE',
}
